import React, { useState, useEffect } from 'react'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import { startLoading, doneLoading } from '../../../utils/loading'
import { getLawDocumentForm } from '../../../redux/actions/lawDocumentform'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import LawDocumentformWidget from '../../../widgets/lawDocumentform/LawDocumentformWidget'

export default function LawDocumentform() {
  const [isEditWidget, setIsEditWidget] = useState({})
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [showEditAll, setShowEditAll] = useState()
  const [error, setError] = useState()
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')

  useEffect(() => {
    console.log('load AttachFilesView projectId', projectId)
    handleGetSchema()
  }, [])

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()
    try {
      const _schema = await getLawDocumentForm()
      // console.log('AttachFilesView => ', _schema)
      setSchema(_schema.model)
      // setIsEditWidget({
      //   attachment: mockSchema.forms?.attachment?.attachFiles?.value.length > 0 ? false : true,
      // })

      // setShowEditAll(!mockSchema.forms?.attachment?.disabled)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <SidebarProposal isLegalManagement>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal isLegalManagement>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <>
      <SidebarProposal isLegalManagement>
        <ContentHeader header={schema.header} subHeader={schema.subHeader} />

        {schema?.forms?.attachment && (
          <>
            <LawDocumentformWidget
              showCommandButton={!schema.forms.attachment.disabled}
              // isEdit={isEditWidget.attachment}
              // onChangeIsEdit={(_isEdit) =>
              //   handleOnChangeIsEdit('attachment', _isEdit, setIsEditWidget)
              // }
              isEdit={true}
              schema={schema.forms.attachment}
              loadMenu={true}
            />
            <br />
          </>
        )}
      </SidebarProposal>
    </>
  )
}
